import { array, struct, union } from 'io-ts/Decoder';

import { Id as TransactionId } from '../../../transaction/Id';

export const Request = union(
	struct({
		transactionIds: array(TransactionId),
	})
);
